import { memo } from 'react';
import { LuX } from 'react-icons/lu';
import { components, MultiValueRemoveProps } from 'react-select';
import { Flex, Icon, Tag } from '@chakra-ui/react';

import { ControlledSelectOption } from '../types/ControlledSelectOption';

const MultiValueRemoveComponent = <IsMulti extends boolean = false>({
  children,
  ...props
}: MultiValueRemoveProps<ControlledSelectOption, IsMulti>) => (
  <Tag.EndElement
    _hover={{ color: 'red' }}
    alignItems="center"
    as={Flex}
    cursor="pointer"
    justifyContent="center"
  >
    <Tag.CloseTrigger asChild>
      <components.MultiValueRemove {...props}>
        <Icon as={LuX} boxSize={3} />
      </components.MultiValueRemove>
    </Tag.CloseTrigger>
  </Tag.EndElement>
);

export const MultiValueRemove = memo(
  MultiValueRemoveComponent,
) as typeof MultiValueRemoveComponent;
